import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/home/home.vue"),
    meta: {
      title: "帮助中心"
    }
  },
  {
    path: "/detail",
    name: "detail",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/home/detail.vue"),
    meta: {
      title: "\u200E"
    }
  }
];

const router = new VueRouter({
  routes
});
router.beforeEach((from, to, next) => {
  if (from.meta.title) {
    document.title = from.meta.title || "食行生鲜";
  } else {
    document.title = "食行生鲜";
  }
  next();
});
export default router;
